module.exports = __webpack_public_path__ + "img/HonoraryDoctorateEducation.7f008673.jpg";